"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getIcon;

var _react = _interopRequireDefault(require("react"));

var _icons = require("../icons");

function getIcon(files, error, isDragOver) {
  if (!isDragOver) {
    if (error) {
      return _react["default"].createElement(_icons.ErrorIcon, null);
    }

    if (files && files.length === 1) {
      return _react["default"].createElement(_icons.FileIcon, null);
    }

    if (files && files.length > 1) {
      return _react["default"].createElement(_icons.FilesIcon, null);
    }
  }

  return _react["default"].createElement(_icons.UploadIcon, null);
}